import Vue from 'global-vue'

import di from 'di';

import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import { onError } from 'apollo-link-error';
import VueApollo from 'vue-apollo'

import introspectionQueryResultData from 'app/fragmentTypes.json'

export default class {

    run(){

        const config = di.get('config');

        const httpLink = new HttpLink({
            uri: config.apiUrl + '/graphql',
        });

        const authenticationLink = new ApolloLink((operation, forward) => {

            let session = di.get('auth').getSession();
            let token = session ? session.getToken() : null;

            if(!token){
                token = window.TEMP_TOKEN || null;
            }

            if(token) {

                operation.setContext({
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            }

            return forward(operation);
        });

        const errorLink = onError(({ networkError }) => {

            if (networkError && networkError.statusCode === 401) {

                di.get('auth').logout();
            }
        });

        const link = errorLink.concat(authenticationLink.concat(httpLink));

        const fragmentMatcher = new IntrospectionFragmentMatcher({
            introspectionQueryResultData
        });

        const cache = new InMemoryCache({
            fragmentMatcher
        });

        const apolloClient = new ApolloClient({
            link,
            cache
        });


        di.set('apollo', apolloClient);
        Vue.use(VueApollo);
    }
}
